export default __webpack_public_path__ + "static/media/cake2.575551a5.jpg";